import { useCallback } from "react"
import { aIsMuted, aIsVolumeSliderVisible, aVolume, useAtom } from "~/atoms"
import { Tooltip } from "~/components/ui"
import useIsPhone from "~/hooks/useIsPhone"
import { cn } from "~/utils"
import { MuteIcon, VolumeLoudIcon, VolumeSoftIcon } from "../icons"
import { ControlButton } from "./control-button"
import VolumeSlider from "./volume-slider"

export default function MuteControl({ className }: { className?: string }) {
  const [isMuted, setIsMuted] = useAtom(aIsMuted)
  const [isVolumeSliderVisible, setIsVolumeSliderVisible] = useAtom(
    aIsVolumeSliderVisible
  )
  const [volume, setVolume] = useAtom(aVolume)
  const isPhone = useIsPhone()

  const renderVolumeIcon = useCallback(() => {
    if (isMuted || volume === 0) {
      return <MuteIcon className="h-6 w-6 text-white" />
    } else if (volume < 0.6) {
      return <VolumeSoftIcon className="h-6 w-6 text-white" />
    }

    return <VolumeLoudIcon className="h-6 w-6 text-white" />
  }, [isMuted, volume])

  return (
    <div
      className="flex items-center"
      onMouseEnter={() => setIsVolumeSliderVisible(true)}
    >
      <Tooltip.Provider>
        <Tooltip delayDuration={200}>
          <Tooltip.Trigger asChild>
            <ControlButton
              className={cn(className, isPhone && "!h-8 !px-3")}
              aria-label={isMuted ? "Unmute" : "Mute"}
              onClick={() => {
                if (volume === 0) {
                  setIsMuted(false)
                  setVolume(1)
                } else {
                  setIsMuted(!isMuted)
                }
              }}
            >
              {renderVolumeIcon()}
            </ControlButton>
          </Tooltip.Trigger>
          <Tooltip.Content>{isMuted ? "Unmute" : "Mute"}</Tooltip.Content>
        </Tooltip>
      </Tooltip.Provider>
      <Tooltip.Provider>
        <Tooltip delayDuration={200}>
          <Tooltip.Trigger asChild>
            <div
              className={cn(
                "hidden items-center overflow-hidden transition-all duration-1000 sm:flex",
                !isVolumeSliderVisible && "max-w-0"
              )}
            >
              <VolumeSlider className="-mr-4 w-28 pl-2 pr-6" />
            </div>
          </Tooltip.Trigger>
          <Tooltip.Content>Volume</Tooltip.Content>
        </Tooltip>
      </Tooltip.Provider>
    </div>
  )
}
